import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=19c09ad4&scoped=true"
import script from "./UserDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=19c09ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c09ad4",
  null
  
)

export default component.exports